<template>
  <div class="page_loading">
    <div class="loading_div">
      <div class="loading_circle loading_circle3">
        <div class="loading_circle loading_circle2">
          <div class="loading_circle loading_circle1"></div>
        </div>
      </div>
      <p class="p1">فالیزنت</p>
      <p class="p2">ویترین کسب و کار اینترنتی</p>
      <p class="p3">درحال بارگذاری ...</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "loadingPage",
  data() {
    return {};
  },
};
</script>

<style lang="css" scoped>
@import url(@/assets/style/components/loading/loading.css);
</style>